import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {HttpModule, Http} from '@angular/http';
import { AppComponent } from './app.component';
import {CoreModule} from './core/core.module';
import {AppRoutingModule} from './app.routing.module';
import {NotFoundComponent} from './404.component';
import {TranslateModule, TranslateLoader, TranslateStaticLoader} from 'ng2-translate';
import {AuthModule} from './auth/auth.module';
import {GlobalService} from './global/global.service';
import {SiteNotAvailableComponent} from './site/site-not-available.component';
import {stompConfigFactory} from './core/stomp/stomp.config';
import {StompConfig, StompService} from '@stomp/ng2-stompjs';
import {AuthService} from './auth/auth.service';
import {NgbCarouselConfig} from './shared/carousel/carousel.config';

export function createTranslateLoader(http: Http) {
  return new TranslateStaticLoader(http, '/assets/i18n', '.json');
}


@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    SiteNotAvailableComponent,

  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AppRoutingModule,
    AuthModule,
    CoreModule.forRoot(),
    TranslateModule.forRoot({
      provide: TranslateLoader,
      useFactory: (createTranslateLoader),
      deps: [Http]
    })
  ],
  providers: [
    GlobalService,
    StompService,
    NgbCarouselConfig,
    {
      provide: StompConfig,
      useFactory: (stompConfigFactory),
      deps: [AuthService]
    },

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts